<template>
  <div id="materialAccessories">
    <div class="material" :class="{ minBox: bodyWidth <= 1680 }">
      <div class="material-tit">分销商资料</div>
      <div class="material-box">
        <div
          class="material-info"
          v-for="(item, index) in materialType"
          @click="toDetails(item.option)"
          :key="index"
        >
          <div class="material-cover">
            <img
              v-if="
                item.option == '法人身份证原件照片（正面）' ||
                item.option == '法人身份证原件照片（反面）' ||
                item.option == '股东身份证原件照片（正面）' ||
                item.option == '股东身份证原件照片（反面）'
              "
              src="@/assets/image/bgIDcard.png"
              alt
            />
            <img
              v-else
              src="@/assets/image/bgProfessional QualificationCertificate.png"
              alt
            />
          </div>
          <div class="material-name">{{ item.option }}</div>
        </div>
        <div
          class="material-btn on"
          @click="showMore('员工离职资料')"
          v-if="key != '员工离职资料'"
        >
          更多资料
          <img src="@/assets/image/icon-open.png" alt />
        </div>
        <div
          class="material-btn off"
          @click="key = '-1'"
          v-if="key == '员工离职资料'"
        >
          <img src="@/assets/image/icon-off.png" alt />
          收起
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCompanySettings } from "@/http/api/system";
export default {
  data() {
    return {
      key: "",
      id: this.$route.params.id,
      bodyWidth: 1920,
      isShowWidth: false,
      materialType: [],
    };
  },
  mounted() {
    this.bodyWidth = document.body.clientWidth;
    if (this.bodyWidth > 1680) {
      this.isShowWidth = true;
    } else {
      this.isShowWidth = false;
    }
    this.getSettingsInfo();
  },
  methods: {
    showMore(val) {
      this.key = val;
    },
    toDetails(val) {
      this.$router.push(`/channel/business/material-details/${this.id}?type=${val}`);
    },
    // 获取基础字段
    getSettingsInfo() {
      getCompanySettings().then((res) => {
        res.result.forEach((item) => {
          if (item.name == "Deer.Company.Collection.MaterialType") {
            this.materialType = item.value;
          }
        });

        // let basicMaterialTypeInfo = [],
        //   normalMaterialTypeInfo = [],
        //   firedMaterialTypeInfo = [];
        // res.result.map((item) => {
        //   if (item.name == "Deer.User.BasicMaterialType") {
        //     basicMaterialTypeInfo = item.value;
        //   } else if (item.name == "Deer.User.NormalMaterialType") {
        //     normalMaterialTypeInfo = item.value;
        //   } else if (item.name == "Deer.User.FiredMaterialType") {
        //     firedMaterialTypeInfo = item.value;
        //   }
        // });
        
        // basicMaterialTypeInfo.forEach((item) => {
        //   if (!item.isDefault) {
        //     this.material.basicMaterialTypeInfo.push(item);
        //   }
        // });
        // normalMaterialTypeInfo.forEach((item) => {
        //   if (!item.isDefault) {
        //     this.material.normalMaterialTypeInfo.push(item);
        //   }
        // });
        // firedMaterialTypeInfo.forEach((item) => {
        //   if (!item.isDefault) {
        //     this.material.firedMaterialTypeInfo.push(item);
        //   }
        // });
        
      });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#materialAccessories {
  min-height: calc(100vh - 220px);
  // background-color: #f2f2f2;

  .material {
    position: relative;
    margin-bottom: 26px;
    padding: 25px 20px;
    background-color: #fff;
    min-height: calc(100vh - 215px);
    // box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
    border-radius: $--border-radius-base;
    .material-tit {
      margin-bottom: 24px;
      font-size: 14px;
      font-weight: bold;
      color: #000;
    }

    .material-box {
      @include flex(row, center);
      flex-wrap: wrap;
      .material-info {
        margin-right: 30px;
        margin-bottom: 24px;
        border: 1px solid #ddd;
        width: 225px !important;
      height: 165px !important;
        cursor: pointer;
        .material-cover {
          margin: 9px;
          border: 1px dashed #ddd;
          width: 205px;
          height: 115px;
          @include flex(column, center);
          justify-content: center;
          img {
            height: 30px;
          }
        }
        .material-text {
          margin: 9px;
          border: 1px dashed #ddd;
          width: 170px;
          height: 100px;
          @include flex(column, center);
          justify-content: center;
        }
        .material-name {
          margin: 0 9px 9px;
          color: #444;
        }
      }
    }
    .material-btn {
      @include flex(row, center);
      position: absolute;
      right: 20px;
      top: 68px;
      justify-content: center;
      margin-bottom: 24px;
      padding: 0 8px;
      border: 1px solid #ddd;
      writing-mode: tb-rl;
      height: 144px;
      line-height: 12px;
      font-size: 12px;
      cursor: pointer;
      letter-spacing: 7px;
      color: #444444;
      img {
        margin: 7px 0;
        width: 12px;
      }
    }
  }
  .material:last-child {
    margin-bottom: 0;
  }
  .minBox {
    .material-info {
      width: 225px !important;
      height: 165px !important;
      .material-cover,
      .material-text {
        width: 205px !important;
        height: 122px !important;
      }
    }
    .material-btn {
      height: 165px;
    }
  }
}
</style>
